import { RiskLevelKey } from "@/services/backend/qpm/types/enums";

export class RiskLevelUtil {
  private static descriptions: { [key in RiskLevelKey]: string } = {
    [RiskLevelKey.Unspecified]: "nicht definiert",
    [RiskLevelKey.None]: "kein Risiko",
    [RiskLevelKey.Low]: "geringes Risiko",
    [RiskLevelKey.Medium]: "mittleres Risiko",
    [RiskLevelKey.High]: "hohes Risiko",
  };

  static toLongString(type: RiskLevelKey): string {
    return this.descriptions[type] || "Unknown";
  }
}
